





































































import Vue from 'vue';

import { IFetchQuoteProductDocumentsParams } from '@/services/document';

import DocumentDetailTagPicker from '@/components/document/DocumentDetailTagPicker.vue';

export default Vue.extend({
  components: { DocumentDetailTagPicker },
  name: 'DocumentSearchFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IFetchQuoteProductDocumentsParams
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IFetchQuoteProductDocumentsParams) {
      if (
        params.quote_document__document__tags != null &&
        params.quote_document__document__tags.length > 0
      ) {
        this.filterParams.quote_document__document__tags = params.quote_document__document__tags.map(
          tag => Number(tag)
        );
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
